import { otherOtpOptions } from "../../utils/constants";
import DropdownIcon from "../../assets/icons/DropdownIcon";
import PopUp from "../Popup";
import SuccessIcon from "../../assets/icons/SuccessIcon";
import apiHooks from "../../customHooks/apis";
import { returnAvailableChannels } from "../../utils/helpers";
import "./OtpDialog.css";

interface OptionPadProps {
  icon: React.ReactNode;
  label: string;
  successful: boolean;
  onClick: (label: string) => void;
}
const OtherOtpOptions: React.FC<
  Pick<OptionPadProps, "onClick" | "successful">
> = ({ successful, onClick }) => {
  const { response, loading } = apiHooks.useGetAvailableChannels();

  const handleClickOption = (option: string) => {
    if (!option) return;
    const lowercaseOption = option.trim().toLowerCase();
    const lastword = lowercaseOption.split(" ").reverse()[0];
    onClick(lastword);
  };

  if (loading) return <p>Please wait...</p>;
  if (successful)
    return (
      <PopUp
        icon={<SuccessIcon />}
        title="Request Received"
        message="The OTP will be shared via selected option"
        cancelText="Close"
        onClickBtn={onClick}
      />
    );

  return (
    <div className="d-flex flex-column align-items-center gap-2">
      <span>Choose a way to receive it</span>
      <div>
        {returnAvailableChannels(
          response?.data?.availableOtps,
          otherOtpOptions
        ).map(({ label, icon: Icon }) => (
          <OptionPad
            key={label}
            icon={typeof Icon === "string" ? Icon : <Icon />}
            label={label}
            onClick={handleClickOption}
          />
        ))}
      </div>
    </div>
  );
};

export default OtherOtpOptions;

const OptionPad: React.FC<Partial<OptionPadProps>> = ({
  icon,
  label,
  onClick,
}) => {
  return (
    <div
      className="cursor-pointer d-flex align-items-center gap-2 p-2 dropdownitem transition"
      onClick={() => onClick(label)}
    >
      <div className="option-icon">{icon}</div>
      <span className="me-5">
        {label.includes("BVN") ? "" : "Receive via "}
        {label}
      </span>
      <DropdownIcon className="rotate-arrow ms-auto" />
    </div>
  );
};
